import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCastAvailable = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M25 7H7C5.9 7 5 7.9 5 9V12H7V9H25V23H18V25H25C26.1 25 27 24.1 27 23V9C27 7.9 26.1 7 25 7ZM5 22V25H8C8 23.34 6.66 22 5 22ZM5 18V20C7.76 20 10 22.24 10 25H12C12 21.13 8.87 18 5 18ZM5 14V16C9.97 16 14 20.03 14 25H16C16 18.92 11.07 14 5 14Z" })
});
export { SvgCastAvailable as ReactComponent };
